// global.d.ts or a similar declaration file

// This ensures the file is treated as a module.
export {};

declare global {
  // Extend the NodeJS.Global interface to include 'log'
  // The '...args: any[]' syntax allows the function to accept any number of arguments of any type.
  // eslint-disable-next-line no-var
  var log: (...args: any[]) => void;
}

// In your main setup file (e.g., index.ts)
global.log = (...args: any[]) => {
  // We only log if the environment is 'development'
  if (process.env.NODE_ENV === 'development') {
    // The spread syntax '...args' passes all arguments directly to console.log
    console.log(...args);
  }
};